import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-gray-900 text-white py-12" data-id="element-59">
      <div className="container mx-auto px-4 md:px-6" data-id="element-60">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-61">
          <div data-id="element-62">
            <h3 className="text-xl font-bold mb-4" data-id="element-63">
              Commerce CFO Roundtable 2025
            </h3>
            <p className="text-gray-400" data-id="element-64">
              An exclusive gathering of CFOs at the Porsche Experience Center
              Los Angeles.
            </p>
          </div>
          <div data-id="element-65">
            <h3 className="text-xl font-bold mb-4" data-id="element-66">Quick Links</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-67">
              <li data-id="element-68">
                <Link to="/" className="hover:text-red-500 transition-colors" data-id="element-69">
                  Home
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/sponsorship" className="hover:text-red-500 transition-colors" data-id="element-71">
                  Sponsorship
                </Link>
              </li>
              <li data-id="element-72">Email: info@commercecfotable.com</li>
            </ul>
          </div>
          <div data-id="element-73">
            <h3 className="text-xl font-bold mb-4" data-id="element-74">Event Details</h3>
            <ul className="space-y-2 text-gray-400" data-id="element-75">
              <li data-id="element-76">Date: November 18, 2025</li>
              <li data-id="element-77">Time: 8:00 AM - 2:30 PM</li>
              <li data-id="element-78">Location: Porsche Experience Center, Los Angeles</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-10 pt-6 text-center text-gray-500 text-sm" data-id="element-79">
          <p data-id="element-80">© 2025 Commerce CFO Roundtable. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}